import controller from './masterpass-card-add-otp-dialog.controller';
import './masterpass-card-add-otp-dialog.less'

export default {
  controller,
  template: require('./masterpass-card-add-otp-dialog.html')
};



// WEBPACK FOOTER //
// src/app/buy/masterpass-card-add-otp-dialog/masterpass-card-add-otp-dialog.component.ts